export const _setSingleSpedNote = (state, action) => {
  state.singleSpedNote = action.payload;
};

export const _setIsNewSpedNote = (state, action) => {
  state.isNewSpedNote = action.payload;
};

export const _setIsBulkSpedNote = (state, action) => {
  state.isBulkSpedNote = action.payload;
};

export const _setSelectedStudents = (state, action) => {
  state.selectedStudents = action.payload;
};
